// extracted by mini-css-extract-plugin
module.exports = {"boxes":"MenuPage_boxes__18fl9"};